<template lang="pug">
  div.box
    .p-a.white.lt.box-shadow
      p.m-b-0.inline
        a(:href='indexUrl') Payment
      a.nav-link.pull-right(:disabled="onLoading('save-payment')" :href='indexUrl')
        i.material-icons keyboard_arrow_left
        span Payment List

    v-server-table(
    :url="datatable.api"
    :name="datatable.name"
    :columns="datatable.columns"
    :options="datatable.options"
    ref="datatable"
    )
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Auth from '@js/plugins/auth';
import types from './payment-types';

const TableName = 'VUETABLE_PAYMENT_RESTORE';

export default {
    data() {
        let canManagePayments = Auth.hasPermissionTo(
            'franchise_manage_payments',
        );

        return {
            datatable: {
                api: Laroute.route('franchise.setting.payment.restore'),
                name: TableName,
                columns: ['name', 'type', 'outlets'],
                options: {
                    checkbox: canManagePayments,
                    checkboxActions: [
                        {
                            title: 'Restore Payments',
                            callback: () => {
                                this.submitRestore();
                            },
                        },
                    ],
                    sortable: ['name', 'type'],
                    orderBy: {
                        column: 'name',
                        ascending: 1,
                    },
                    customFilters: ['outlets', 'types'],
                    initFilters: {
                        outlets: [],
                        types: [],
                    },
                    templates: {
                        type(h, row) {
                            let type = types.find(obj => obj.type === row.type);

                            if (type !== undefined) {
                                return type.name;
                            }

                            return '';
                        },

                        outlets(h, row) {
                            return require('./outlets.jsx')(h, row);
                        },
                    },
                },
            },
            payment: null,
        };
    },

    computed: {
        ...mapGetters('payment', ['filterOutlets', 'filterTypes']),
        indexUrl() {
            return Laroute.route('franchise.setting.payment.index');
        },
    },

    watch: {
        filterOutlets: function(o, n) {
            if (o === n) {
                // For some reason this is called even though there was no changes
                return;
            }

            this.$store.commit(`${TableName}/SET_CUSTOM_FILTER`, {
                filter: 'outlets',
                value: this.filterOutlets,
            });
        },

        filterTypes: function(o, n) {
            if (o === n) {
                return;
            }

            this.$store.commit(`${TableName}/SET_CUSTOM_FILTER`, {
                filter: 'types',
                value: this.filterTypes,
            });
        },
    },

    mounted() {
        this.focusSearch();
    },

    methods: {
        ...mapActions('payment', ['getPaymentBySource', 'restorePayment']),

        addCustomPayment(payment) {
            this.showPopupForm({
                type: 4,
                source: payment,
                require_reference: true,
                meta: {},
                outlets: [],
            });
        },

        focusSearch() {
            this.$nextTick(() => {
                $(this.$el)
                    .find('.VueTables__search-field input')
                    .focus();
            });
        },

        refresh() {
            this.$refs.datatable.getData();
        },

        showPaymentForm(payment = null) {
            if (payment !== null) {
                this.showPopupForm(payment);
            }
        },

        showPopupForm(payment = null) {
            this.$emit('payment-clicked', payment);
        },

        showDeletedPayment() {
            window.location.href = Laroute.route(
                'franchise.setting.payment.restore',
            );
        },

        bulkData() {
            return {
                ids: this.$store.getters[
                    'VUETABLE_PAYMENT_RESTORE_CHECKBOX/getSelected'
                ],
            };
        },

        submitRestore() {
            this.restorePayment(this.bulkData())
                .then(u => {
                    this.refresh();
                    this.showToastrSuccess(
                        'The selected payment successfully restore',
                    );
                    this.clearSelected();
                })
                .catch(e => {});
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/payment/settings-payment-restore-datatable.vue